module.exports = __webpack_public_path__ + "img/MAC1133_1-1.65c2d5eb.jpg";